// extracted by mini-css-extract-plugin
export var articleLink = "Subtopics-module--article-link--a042f";
export var firstCategory = "Subtopics-module--first-category--745f3";
export var header = "Subtopics-module--header--ae36f";
export var subtopicsSectionWrapper = "Subtopics-module--subtopics-section-wrapper--29952";